import React, { forwardRef, HtmlHTMLAttributes, memo, ReactNode } from "react";
import classnames from "classnames";

import styles from "./styles.module.scss";

export type InlineCTAPropsType = HtmlHTMLAttributes<HTMLDivElement> & {
  backgroundImage?: ReactNode;
  text?: ReactNode;
  supportingText?: ReactNode;
};

export const InlineCTA = memo(
  forwardRef<HTMLDivElement, InlineCTAPropsType>(
    (
      { className, children, text, supportingText, backgroundImage, ...props },
      ref,
    ) => {
      return (
        <div
          {...props}
          className={classnames(className, styles.root)}
          ref={ref}
        >
          {backgroundImage && (
            <div className={styles.backgroundImage}>
              {typeof backgroundImage === "object" ? (
                backgroundImage
              ) : (
                <img src={String(backgroundImage)} alt="alt" />
              )}
            </div>
          )}
          <div className={styles.wrapper}>
            <div className={classnames(styles.header)}>
              {text && (typeof text === "string" ? <p className={styles.text}>{text}</p> : text)}
              {supportingText && (typeof supportingText === "string" ? <p className={styles.supportingText}>{supportingText}</p> : text)}
            </div>
            {children}
          </div>
        </div>
      );
    },
  ));
